<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
    v-bind:style="{ 'background-image': 'url(' + imagenFondo + ') !important' }"
  >
    <img
      v-if="ingresoLogo"
      :src="ingresoLogo.imagen"
      id="logo"
      v-bind:style="logoStyle"
    />
    <b-card v-if="!isLogged && !fromCu">
      <h4>Hola! por favor ingresa tu ClaveÚnica para acceder al formulario.</h4>
      <div
        class="flex flex-wrap mt-5 justify-center"
      >
        <button-clave-unica
          size="lg"
          @click="redirectToClaveUnica()"
        />
      </div>
    </b-card>
    <div v-else>
      <vs-button
        color="warning"
        size="small"
        class="mt-3 ml-3"
        @click="signOut()"
      >
        <span>Salir</span>
      </vs-button>
      <Wizard :company-to-load="currentCompany"/>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';
import Wizard from '@/febos/chile/dnt/vistas/Wizard';
import ButtonClaveUnica from '@/components/ButtonClaveUnica';

export default {
  mixins: [PersonalizacionMixin],
  components: { ButtonClaveUnica, Wizard },
  data() {
    return {
      isLogged: false
    };
  },
  computed: {
    ...mapGetters('Personalizacion', [
      'colors',
      'empresaPortal'
    ]),
    ...mapGetters('Usuario', [
      'currentUser',
      'fromCu'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    currentCompany() {
      console.log('company');
      if (window.location.hostname.toLocaleLowerCase().includes('vue.')) {
        return '61221000-4'; // RUT SISS;
      }
      return this.empresaPortal || this.companyToLoad || this.company.iut;
    },
  },
  methods: {
    ...mapActions('Usuario', ['loadPermissions', 'signInSSOCU', 'signOut']),
    ...mapActions('Empresas', ['selectCompany', 'setDomainCompany']),
    async redirectToClaveUnica() {
      this.$vs.loading();
      const { from } = this.$route.query;

      const domain = window.location.href.replace('https://', '').replace('http://', '').split('/');
      const ref = window.location.href.split('?')[0];
      const urlOk = encodeURIComponent(
        `${ref}?from=${from || 'entryExternalFile'}&estado=ok&idProceso={id_proceso}&seguimiento={seguimiento}`
      );
      const urlError = encodeURIComponent(
        `${ref}?from=${from || 'entryExternalFile'}&estado=error&idProceso={id_proceso}&seguimiento={seguimiento}`
      );
      return window.open(
        `https://api.febos.cl/${process.env.VUE_APP_AMBIENTE}/usuarios/sso/claveunica?empresa=${this.currentCompany}&fromPublic=si&publicScope=expedientes.ingreso.externo&dominioPortal=${domain[0]}&urlCallback=${urlOk}&urlCallbackError=${urlError}`,
        '_self'
      );
    }
  },
  async mounted() {
    try {
      const { query } = this.$route;
      const { idProceso } = query;
      if (!this.isLogged && idProceso) {
        const { estado } = this.$route.query;
        if (estado === 'ok') {
          try {
            this.$vs.loading();
            await this.signInSSOCU(idProceso);
            await this.setDomainCompany({ iut: this.companyToLoad });
            await this.loadPermissions();
            setTimeout(() => {
              const logout = 'https://api.claveunica.gob.cl/api/v1/accounts/app/logout';
              window.open(logout, '_self');
            }, 1000);
          } finally {
            this.$vs.loading.close();
            query.idProceso = undefined;
            await this.$router.replace({
              ...this.$router.currentRoute,
              query: {
                from: query.from
              }
            });
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  },
  props: {
    companyToLoad: {
      type: String,
      required: false,
      default: '61221000-4'
    }
  }
};
</script>

<style lang="scss">

@import "~vue-step-progress/dist/main.css";

</style>
